import { FormEvent, useEffect, useState } from 'react';

import { TextareaWithConfirm } from 'shared-components';

import { ITravelStatus } from '../../../../../../../../../types';

interface IProps {
  setComplete: (status: boolean) => void;
  additionalAnswers: {
    setAnswers: (data: Omit<ITravelStatus, 'status'>) => void;
  };
}
export const Defer = (props: IProps) => {
  const {
    additionalAnswers: { setAnswers },
    setComplete
  } = props;
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (reason.length) {
      setAnswers({ deferReason: reason });
      setComplete(true);
    } else {
      setComplete(false);
    }
    // eslint-disable-next-line
  }, [reason]);

  return (
    <TextareaWithConfirm
      key={'Defer'}
      id={'Defer'}
      value={reason}
      label={`Please explain your situation`}
      onChange={(evt: FormEvent<HTMLInputElement>) => {
        setReason(evt.currentTarget.value);
      }}
    />
  );
};
